module.exports = __webpack_public_path__ + "img/she_1.b6183b22.png";